module.exports = __webpack_public_path__ + "static/media/bannerImage3-m.b1f46240.jpg";